'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'paperclip';
var width = 448;
var height = 512;
var aliases = [128206];
var unicode = 'f0c6';
var svgPathData = 'M370 73c-26-26-68.1-26-94.1 0L84 265C40.3 308.6 40.3 379.4 84 423s114.4 43.6 158.1 0L394 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L276 457c-62.4 62.4-163.5 62.4-225.9 0S-12.4 293.4 50 231L242 39C286.7-5.7 359.2-5.7 404 39s44.7 117.2 0 161.9L220.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L266 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L148.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L370 167c26-26 26-68.1 0-94.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPaperclip = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;